import useSWR from 'swr'

import { apiClient } from 'common/api'
import { useOrgName } from 'common/hooks/useOrgName'

/**
 * Convenience hook to get the current org object
 */
export const useCurrentOrg = () => {
  /**
   * Get current org name
   */
  const currentOrg = useOrgName()

  /**
   * Get the current orgUid
   */
  const { data, error } = useSWR(currentOrg ? `core/tenants/${currentOrg}` : null, (url) =>
    apiClient({ url })
  )
  const isLoading = !data && !error

  const org = data || {}
  return {
    org,
    isLoading,
    error,
  }
}
